module.exports = __webpack_public_path__ + "static/divas3-4dfc74bdf23b5e5391e61c99b9a9092e.jpg";